import React from 'react';
import css from './SectionDeliveryOptions.module.css';


const SectionDeliveryOptions = ({ publicData, author, selectedDelivery, onDeliveryChange }) => {
  const { pickupEnabled, shippingEnabled, dealerName: listingDealerName } = publicData || {};
  const authorPublicData = author?.attributes?.profile?.publicData || {};
  const dealerName = listingDealerName || authorPublicData.businessName || 'Store';

  if (!pickupEnabled && !shippingEnabled) return null;

  const handleChange = (method) => {
    if (onDeliveryChange) onDeliveryChange(method);
  };

  return (
    <div className={css.root}>
      {pickupEnabled && (
        <label className={`${css.option} ${selectedDelivery === 'pickup' ? css.optionSelected : ''}`}>
          <input
            type="radio"
            name="deliveryMethod"
            value="pickup"
            checked={selectedDelivery === 'pickup'}
            onChange={() => handleChange('pickup')}
            className={css.radioInput}
          />
          <div className={css.optionContent}>
            <p className={css.optionTitle}>
              FREE Pickup at <span className={css.storeName}>{dealerName}</span>
            </p>
          </div>
        </label>
      )}


      {shippingEnabled && (
        <label className={`${css.option} ${selectedDelivery === 'shipping' ? css.optionSelected : ''}`}>
          <input
            type="radio"
            name="deliveryMethod"
            value="shipping"
            checked={selectedDelivery === 'shipping'}
            onChange={() => handleChange('shipping')}
            className={css.radioInput}
          />
          <div className={css.optionContent}>
            <p className={css.optionTitle}>Shipped To You</p>
            <p className={css.optionDesc}>Arrives in 3-5 business days</p>
            <p className={css.optionDesc}>Costs calculated at checkout.</p>
          </div>
        </label>
      )}
    </div>
  );
};

export default SectionDeliveryOptions;
